import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalConfig, modalContent } from '../../constants/modal.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, TooltipModule, DropdownModule],
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() modalConfig!: ModalConfig;
  @Input() lookupMessages: any = {};
  @Output() emitData = new EventEmitter<any>();
  selectedStaffMember: any = null;
  dropdownTouched: boolean = false;
  dropdownError: string = '';
  signatureErrors: { [fieldName: string]: string } = {};
  signatureValid: { [fieldName: string]: boolean } = {};
  userFullName: string = '';

  constructor(public activeModal: NgbActiveModal) {
    // Modal component constructor
  }

  onDropdownChange() {
    if (this.modalConfig?.dynamicContent && this.modalConfig?.hasDropdown) {
      const selectedOption = this.modalConfig.dropdownOptions?.find(option =>
        String(option.value) === String(this.selectedStaffMember)
      );

      const selectedStaffName = selectedOption?.label || '';
      this.modalConfig.modalContent = modalContent.assignAppToStaffMember(selectedStaffName);
      this.dropdownError = '';
    }
    if (this.selectedStaffMember) {
      this.dropdownError = '';
    }
  }

  onDropdownFocusOut() {
    this.dropdownTouched = true;
    if (!this.selectedStaffMember) {
      this.dropdownError = 'Please select a staff member.';
    } else {
      this.dropdownError = '';
    }
  }

  isAssignButtonDisabled(): boolean {
    if (this.modalConfig?.hasDropdown && this.modalConfig?.dynamicContent) {
      return !this.selectedStaffMember || this.selectedStaffMember === null;
    } else if (this.modalConfig?.modalInputArray && this.modalConfig?.modalInputArray.length > 0) {
      for (let inputField of this.modalConfig?.modalInputArray) {
        if (!inputField.value || inputField.value.trim() === '') {
          return true;
        }
        // Check if this field requires signature validation
        if (inputField.fieldName === 'strFullName' && !this.signatureValid[inputField.fieldName]) {
          return true;
        }
      }
    }
    return false;
  }

  onInputChange(inputField: any): void {
    const trimmedValue = inputField.value?.trim() || '';

    // Special handling for signature field
    if (inputField.fieldName === 'strFullName') {
      if (!trimmedValue) {
        this.signatureErrors[inputField.fieldName] = '';
        this.signatureValid[inputField.fieldName] = false;
        inputField.error = '';
      } else {
        // Normalize both strings for comparison
        const normalizedSignature = trimmedValue.toLowerCase().replace(/\s+/g, ' ');
        const normalizedUserName = this.userFullName.toLowerCase().replace(/\s+/g, ' ');

        if (normalizedSignature === normalizedUserName) {
          this.signatureErrors[inputField.fieldName] = '';
          this.signatureValid[inputField.fieldName] = true;
          inputField.error = '';
        } else {
          this.signatureErrors[inputField.fieldName] = 'Signature must match your name on record';
          this.signatureValid[inputField.fieldName] = false;
          const defaultMsg = 'Enter your name as it appears on your application.';
          const errorMsg = this.lookupMessages && this.lookupMessages['M0068'] ? String(this.lookupMessages['M0068']).trim() : defaultMsg;
         // inputField.error = `<span class="text-danger">${errorMsg || defaultMsg}</span>`;
        }
      }
    }
  }

  onSignatureFocusOut(inputField: any): void {
    const trimmedValue = inputField.value?.trim() || '';
    if (inputField.fieldName === 'strFullName' && !trimmedValue) {
      inputField.error = '<span class="text-danger">Signature is required.</span>';
    }
  }

  getButtonClasses(modalButton: any): string {
    const isSingleButton = this.modalConfig?.buttons?.length === 1;
    const isDeleteButton = modalButton?.text?.toLowerCase() === 'delete' && this.modalConfig?.isDangerButton;
    
    if (isSingleButton) {
      if(modalButton.btnOutline) {
        return 'btn btn-outline';
      }
      return isDeleteButton ? 'btn btn-danger btn-radius' : 'btn btn-primary btn-radius';
    } else {
      if (modalButton.btnOutline) {
        return 'btn w-50 btn-outline';
      } else {
        return isDeleteButton ? 'btn w-50 btn-danger btn-radius' : 'btn w-50 btn-primary btn-radius';
      }
    }
  }

  closeModal(reason: any, navigateTo?: string): void {
    const inputData: any = {};
    if (this.modalConfig?.modalInputArray && this.modalConfig.modalInputArray.length > 0) {
      for (let inputField of this.modalConfig.modalInputArray) {
        inputData[inputField.fieldName] = inputField.value;
      }
    }

    const emitPayload = {
      confirmed: reason === 'Y',
      code: reason,
      buttonCode: reason,
      selectedStaffMember: this.selectedStaffMember,
      navigate: navigateTo,
      data: inputData
    };
    this.emitData.emit(emitPayload);
    this.activeModal.close(emitPayload);
  }
}
